import { createTheme, Theme, tooltipClasses } from '@mui/material'
import light from '@vapor/material/themes/light'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

export const customTheme = createTheme(
  light as Theme, //
  {
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            padding: 0,
            background: '#F6F8F8', // Background color for input controls
            '& .MuiInputBase-input.MuiOutlinedInput-input': {
              padding: '2px 10px',
            },

            '&.MuiInputBase-sizeSmall': {
              minHeight: 'unset',
            },

            '&.MuiOutlinedInput-root': {
              '&.MuiInputBase-fullWidth.MuiInputBase-sizeSmall': {
                minHeight: 'unset', // reset default size of 40px for controls with
              },
            },

            '& .MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputSizeSmall': {
              minHeight: 'unset',
              height: '28px',
              lineHeight: '28px',
              padding: '2px 10px',
            },

            '&.Mui-focused': {
              background: '#F6F8F8', // Background color for input controls
            },

            '& .MuiInputBase-input.MuiOutlinedInput-input:read-only': {
              background: 'none!important',
            },
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            padding: 'unset',
            '& .MuiOutlinedInput-root': {
              padding: 'unset',
            },
            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
              padding: 'unset',
            },

            '& .MuiInputBase-input.MuiOutlinedInput-input': {
              padding: '2px 10px',
            },

            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiOutlinedInput-input': {
              padding: '2px 10px',
            },
          },
        },
        defaultProps: {
          popupIcon: <KeyboardArrowDownIcon />,
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            '& .MuiInputBase-input.MuiOutlinedInput-input:read-only': {
              background: 'none!important',
            },

            '& .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input': {
              background: 'none!important',
            },

            '&.MuiInputBase-sizeSmall': {
              minHeight: 'unset!important',
              '& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.MuiSelect-select': {
                paddingTop: '2px',
                paddingBottom: '2px',
              },
            },
          },
        },
      },
      MuiTooltip: {
        defaultProps: {
          followCursor: true,
          placement: 'bottom-start',
          slotProps: {
            popper: {
              sx: {
                [`&.${tooltipClasses.popper}[data-popper-placement="bottom-start"] .${tooltipClasses.tooltip}:not(.${tooltipClasses.tooltipArrow})`]: {
                  marginLeft: '12px!important',
                },
                [`&.${tooltipClasses.popper}[data-popper-placement="bottom-end"] .${tooltipClasses.tooltip}:not(.${tooltipClasses.tooltipArrow})`]: {
                  marginRight: '12px!important',
                },
              },
            },
          },
        },
      },
      MuiSlider: {
        defaultProps: {
          slotProps: {
            mark: {
              sx: { transform: 'translate(-6px, -6px)' },
            },
          },
        },
      },
      MuiLink: {
        defaultProps: {},
        styleOverrides: {
          root: {
            '&.MuiLink-underlineAlways:hover': { textDecorationColor: 'var(--YankeesBlue)' },
            '&.MuiLink-underlineAlways:visited': { textDecorationColor: 'initial' },
          },
        },
      },
    },
  } as Partial<Theme>,
)
